import API from "@/services/api"
import { CategoryResponse } from "../types/CRMCategorySelectField";

export enum Endpoints {
  Categories = "/crm/cases/categories/",
  UnsignedCategories = "/crm/cases/categories/?unsigned=true"
}

const getCategories = async (unsigned: boolean) => {
  const endpoint = unsigned ? Endpoints.UnsignedCategories : Endpoints.Categories

  try {
    const response = await API.get<CategoryResponse>({
      endpoint: endpoint,
      versions: [1]
    });
    return {
      status: response.promise.status,
      data: response.promise.data
    }
  } catch (error) {
    throw new Error("Failed to get categories. Please try again later.");
  }
}

export default {
  getCategories
};